export class PushSubscriptionRequest {
	endpoint: string;
	auth: string;
	p256dh: string;
}
